export const AUTH_PASSWORD_MIN_LENGTH = 9;

export const AUTH_PASSWORD_CONFIRMATION_ERROR = 'Passwords must match.';

const joinRequirements = (requirements: string[]) => {
  if (requirements.length === 1) {
    return requirements[0];
  }

  if (requirements.length === 2) {
    return `${requirements[0]} and ${requirements[1]}`;
  }

  return `${requirements.slice(0, -1).join(', ')}, and ${requirements[requirements.length - 1]}`;
};

export const getAuthPasswordRequirementsMessage = (password: string) => {
  const missingRequirements: string[] = [];
  const requiresMinimumLength = password.length < AUTH_PASSWORD_MIN_LENGTH;

  if (!/[A-Za-z]/.test(password)) {
    missingRequirements.push('a letter');
  }

  if (!/\d/.test(password)) {
    missingRequirements.push('a number');
  }

  if (!/\W/.test(password)) {
    missingRequirements.push('a special character');
  }

  if (!requiresMinimumLength && missingRequirements.length === 0) {
    return undefined;
  }

  if (requiresMinimumLength && missingRequirements.length > 0) {
    return `At least ${AUTH_PASSWORD_MIN_LENGTH} characters are required, and must include ${joinRequirements(missingRequirements)}.`;
  }

  if (requiresMinimumLength) {
    return `At least ${AUTH_PASSWORD_MIN_LENGTH} characters are required.`;
  }

  return `Must include ${joinRequirements(missingRequirements)}.`;
};

export const getDefaultAuthPasswordRequirementsMessage = () =>
  `At least ${AUTH_PASSWORD_MIN_LENGTH} characters are required, and must include a letter, a number, and a special character.`;

export const AUTH_PASSWORD_CHECKS = [
  `At least ${AUTH_PASSWORD_MIN_LENGTH} characters`,
  'At least 1 letter',
  'At least 1 number',
  'At least 1 special character',
  'Passwords must match',
] as const;

export const AUTH_PASSWORD_RULES: RegExp[] = [
  new RegExp(`^\\S{${AUTH_PASSWORD_MIN_LENGTH},}$`),
  /[A-Za-z]/,
  /\d/,
  /\W/,
];
